module.exports = __webpack_public_path__ + "static/media/chart-line-solid-dark.69760fbb.png";